function getStringValue(source: any, keys: string[]): string {
    for (const key of keys) {
        const value = source?.[key]
        if (typeof value === 'string' && value.trim()) {
            return value.trim()
        }
    }

    return ''
}

function pickFromSources(sources: any[], keys: string[]): string {
    return sources.map((source) => getStringValue(source, keys)).find(Boolean) || ''
}

export function getUserInitials(user: any, options: { profileFirst?: boolean, emailFallback?: boolean | string } = {}): string {
    const { profileFirst = false, emailFallback = false } = options
    const sources = profileFirst
        ? [user?.profile, user, user?.user?.profile, user?.user]
        : [user, user?.profile, user?.user, user?.user?.profile]

    const firstName = pickFromSources(sources, ['first_name', 'firstName', 'given_name', 'givenName'])
    const lastName = pickFromSources(sources, ['last_name', 'lastName', 'family_name', 'familyName', 'surname'])
    const middleName = pickFromSources(sources, ['middle_name', 'middleName', 'patronymic'])
    const fullName = pickFromSources(sources, ['full_name', 'fullName', 'display_name', 'displayName', 'name'])
    const nameParts = fullName.split(/\s+/).filter(Boolean)

    const firstInitial = firstName[0] || nameParts[0]?.[0] || ''
    const lastInitial = lastName[0] || nameParts[1]?.[0] || middleName[0] || ''
    const initials = (firstInitial + lastInitial).toUpperCase()

    if (initials || !emailFallback) {
        return initials
    }

    const email = pickFromSources(sources, ['email'])
    const fallback = typeof emailFallback === 'string' ? emailFallback : 'U'
    return email[0]?.toUpperCase() || fallback
}
